import { render, staticRenderFns } from "./aiBeautify.vue?vue&type=template&id=6fa0bee4&scoped=true"
import script from "./aiBeautify.vue?vue&type=script&lang=js"
export * from "./aiBeautify.vue?vue&type=script&lang=js"
import style0 from "./aiBeautify.vue?vue&type=style&index=0&id=6fa0bee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0bee4",
  null
  
)

export default component.exports